import { render, staticRenderFns } from "./App.vue?vue&type=template&id=450b8850&"
import script from "./utils/scrollDownDisappear.js?vue&type=script&lang=js&"
export * from "./utils/scrollDownDisappear.js?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports